import { GridRowId } from "@mui/x-data-grid";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

import { useBulkUetdsRegisterMutation } from "@/requests/tracking.mutations";

function useBulkUETDS() {
    const { mutateAsync, isPending } = useBulkUetdsRegisterMutation();
    const { t } = useTranslation();

    const handleBulkUETDS = async (ids: string[]) => {
        if (isPending || !ids.length) return;
        const responses = await mutateAsync({ taskIds: ids });
        const completedList: GridRowId[] = [];

        for (const [index, response] of responses.entries()) {
            if (response.ok) completedList.push(response.id);
            setTimeout(() => {
                if (!response.ok) {
                    enqueueSnackbar(response.message || "", {
                        variant: "error",
                    });
                }
                if (index === responses.length - 1 && completedList.length) {
                    enqueueSnackbar(
                        t("responses.bulkUETDSRegister", {
                            count: completedList.length || 1,
                        }),
                        {
                            variant: "success",
                        }
                    );
                }
            }, index * 80);
        }
    };

    return { handleBulkUETDS, isPending };
}

export default useBulkUETDS;
